import React, { Component } from 'react';

import WorkOrderAdditionViewer from './WorkOrderAdditionViewer';
import UploaderWorkOrderAddition from './UploaderWorkOrderAddition';
import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';

class WorkOrderAdditionList extends Component {
  constructor () {
    super();
    this.state = {
      images: [],
      updated: false
    };
  }

  componentDidMount () {
    WorkOrderDataService.retrieveAdditionsOfWorkOrder(this.props.workOrderId).then(data => {
      this.setState({ images:  data});
    });
  }

  handleUpdate(){
    WorkOrderDataService.retrieveAdditionsOfWorkOrder(this.props.workOrderId).then(data => {
      this.setState({ images:  data, updated: true});
    });
  }

  renderForService(){
    if (!AuthenticationService.isService()){
      return (<></>);
    }
    return(
      <>
        <UploaderWorkOrderAddition mode={this.props.mode} workOrderId={this.props.workOrderId} handleUpdate={this.handleUpdate.bind(this)}/>
      </>
    );
  }

  render() {
    if (AuthenticationService.isUser() || AuthenticationService.isWorker()){
      return (<div>&nbsp;</div>)
    }else{
      
      return (
        <div className="col-12 zero_padding">
          <label>{this.props.isUpdated}</label>
          <WorkOrderAdditionViewer images={this.state.images} caption={this.props.caption}  isUpdated={this.state.updated} handleUpdate={this.handleUpdate.bind(this)} mode={this.props.mode}/>
          {this.renderForService()}
        </div>     
      )
    }
  }
}

export default WorkOrderAdditionList;